import { OwnershipType } from './ownership';

export interface CompanySearchFilter {
  search?: string;
  year?: number;
}

export interface EnvironmentReport {
  teeltPlanId: number;
  uoNumber: string;
  name: string;
  address?: string;
  city?: string;
  review?: Review;
}

export interface AggregatieRapportInput {
  registratieJaar?: number;
  bevoegdGezagId?: number;
  bevoegdGezagTypeCode?: string;
  rekenmotorVersie?: string;
}

export interface AggregatieLandelijkRapportInput {
  registratieJaar?: number;
  bevoegdGezagIds: number[];
  bevoegdGezagType?: string;
  rekenmotorVersie?: string;
}

export interface RapportageArchiefItem {
  id: number;
  uoNummer?: number;
  bedrijfsNaam?: string;
  rapportageJaar?: number;
  rekenmotorVersie?: string;
  versieNummer: number;
  isActief: boolean;
  datumIngediend?: string;
  datumBerekend?: string;
  gearchiveerdOp?: string;
}

export interface Review {
  teeltPlanId?: number;
  teeltplanId?: number;
  status?: ReviewStatus;
  reviewStatusId?: ReviewStatus;
  reviewStatusName?: string;
  reason?: string;
  dateOfReview?: Date | string;
  datumVanVerwerking?: Date | string;
  datumBedrijfsbezoek?: string | null;
  type?: ReviewType;
  eigendomstype?: OwnershipType | null;
  eigendomstypeBegindatum?: string | null;
  eigendomstypeEinddatum?: string | null;
  eigendomstype_bevoegd_gezag?: OwnershipType | null;
  eigendomstype_bevoegd_gezag_beginDatum?: string | null;
  eigendomstype_bevoegd_gezag_eindDatum?: string | null;
}

export enum ReviewStatus {
  Onbekend = 0,
  Onvolledig = 1,
  Goedgekeurd = 2,
  Afgekeurd = 3,
}

export enum ReviewType {
  Bureaucontrole = 0,
  Bedrijfsbezoek = 1,
}
